var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuestionMark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Common/question_mark") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "M_business_detail",
    transform: "translate(-207.000000, -736.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(207.000000, 736.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#C0A691",
    cx: 7,
    cy: 7,
    r: 6.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.34667969,8.98828125 C7.34667969,8.70507812 7.37027995,8.49023438 7.41748047,8.34375 C7.46468099,8.19726562 7.58105469,8.04264323 7.76660156,7.87988281 C8.1311849,7.58691406 8.43310547,7.26383464 8.67236328,6.91064453 C8.91162109,6.55745443 9.03125,6.17415365 9.03125,5.76074219 C9.03125,5.1422526 8.84000651,4.65885417 8.45751953,4.31054688 C8.07503255,3.96223958 7.54199219,3.78808594 6.85839844,3.78808594 C6.22688802,3.78808594 5.7117513,3.95003255 5.31298828,4.27392578 C4.91422526,4.59781901 4.71972656,5.04947917 4.72949219,5.62890625 L4.72949219,5.62890625 L4.74414062,5.65820312 L5.88671875,5.65820312 C5.88671875,5.36848958 5.98111979,5.14957682 6.16992188,5.00146484 C6.35872396,4.85335286 6.58821615,4.77929688 6.85839844,4.77929688 C7.17415365,4.77929688 7.41748047,4.8663737 7.58837891,5.04052734 C7.75927734,5.21468099 7.84472656,5.45963542 7.84472656,5.77539062 C7.84472656,6.04882812 7.76985677,6.29866536 7.62011719,6.52490234 C7.4703776,6.75113932 7.26855469,6.98795573 7.01464844,7.23535156 C6.65657552,7.53808594 6.42545573,7.78955078 6.32128906,7.98974609 C6.2171224,8.18994141 6.16341146,8.52278646 6.16015625,8.98828125 L6.16015625,8.98828125 L7.34667969,8.98828125 Z M7.36621094,11 L7.36621094,9.86230469 L6.15527344,9.86230469 L6.15527344,11 L7.36621094,11 Z",
    id: "?",
    fill: "#C0A691",
    fillRule: "nonzero"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/question_mark.707a067b04633a0b06ffb934214750dc.svg";
export { ForwardRef as ReactComponent };